import React from "react";
import Money from "components/money";
import SubscriptionQuantityInput from "components/subs-quantity-input";
import { useSelector } from "react-redux";
import { useGlobalContext } from "context/global";
import extractIdFromGid from "helpers/extract-gid";

const SubscriptionCartItem = ({ item, onRemoved }) => {
	const { translation, } = useGlobalContext();
	const { pendingChanges, activeBox, unavailable_items } = useSelector((state) => state.account.subscription);
	const isDoublePortion = item.name?.includes("Maxi");

	const quantity = item.isDuplicated ? item.totalQuantity : item.quantity;

	const total_price = parseFloat(item.basePrice || item.price) * quantity;

	// Round to fix floating-point precision errors and ensure two decimal places.
	const roundedTotalPrice = Math.round(total_price * 100) / 100;
	let hasDiscount = +item.discountedPrice < roundedTotalPrice;

	const isFree = +item.price === 0;

	let quantityDiscountedPrice = total_price;

	if (pendingChanges && activeBox && item.weightInGrams >= 1000) {
		quantityDiscountedPrice -= activeBox?.discount * item?.quantity * item.weightInGrams / 1000 * (isDoublePortion ? 2 : 1);
		hasDiscount = quantityDiscountedPrice < total_price;
	}

	if (item.weightInGrams <= 1)
		hasDiscount = false;

	const isUnavailable = unavailable_items.find(variant => +extractIdFromGid(variant.id) === item.variantShopifyId);

	return (
		<div className="flex justify-between items-center">
			<img width="60px" src={item.image} alt={item?.name} />
			<div className="flex-[1] flex flex-col ml-2.5">
				<span className="text-base">{item.name}</span>
				{!isFree &&
					<p className="text-sm font-light">
						<span className={`text-sm ${hasDiscount ? "text-green-discount" : ""}`}>
							<Money value={pendingChanges ? quantityDiscountedPrice : item?.discountedPrice} />
						</span>
						{hasDiscount && (
							<span className="line-through ml-2 text-sm text-secondary">
								<Money value={total_price} />
							</span>
						)}
					</p>}
				<div className="flex items-start flex-col gap-1">
					{isFree && <span className="text-xs bg-[#97AB51] text-white w-max rounded-xl px-3 py-1">
						{translation?.product?.freeGift}
					</span>}
					{item?.isOneTimeAdded && <span className="one-time-badge">
						{translation.cart?.oneTime}
					</span>}
					{isUnavailable && <span className="one-time-badge">
						{translation.product?.soldOut}
					</span>}
				</div>
			</div>
			<SubscriptionQuantityInput
				productVariantId={item.variantShopifyId}
				customButtonClass="!w-5 !h-5"
				isInCart
				product={item}
				onRemoved={onRemoved}
			/> 
		</div >
	);
};


export default SubscriptionCartItem;